import * as Yup from "yup";

export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_SPECIAL_CHARACTER_REGEX = /(?=.*[^a-zA-Z0-9\s-"]).*$/;
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_LOWERCASE_REGEX = /[a-z]/;
export const PASSWORD_NUMBER_REGEX = /[0-9]/;

export const buildPasswordSchema = ({
    passwordField = "Password",
    confirmPasswordField = "ConfirmPassword"
} = {}) => Yup.object({
    [passwordField]: Yup
        .string()
        .required("Required")
        .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`)
        .matches(PASSWORD_SPECIAL_CHARACTER_REGEX, "Password must contain at least one special character that is not a hyphen or quotation mark.")
        .matches(PASSWORD_UPPERCASE_REGEX, "Password must contain at least one uppercase letter.")
        .matches(PASSWORD_LOWERCASE_REGEX, "Password must contain at least one lowercase letter.")
        .matches(PASSWORD_NUMBER_REGEX, "Password must contain at least one number"),
    [confirmPasswordField]: Yup
        .string()
        .required("Required")
        .oneOf([Yup.ref(passwordField), null], "Passwords must match")
});

export const getPasswordRuleStates = (password = "", confirmPassword = "") => ([
    {
        id: "length",
        label: `At least ${PASSWORD_MIN_LENGTH} characters`,
        met: password.length >= PASSWORD_MIN_LENGTH
    },
    {
        id: "number",
        label: "At least one number",
        met: PASSWORD_NUMBER_REGEX.test(password)
    },
    {
        id: "uppercase",
        label: "At least one uppercase letter",
        met: PASSWORD_UPPERCASE_REGEX.test(password)
    },
    {
        id: "lowercase",
        label: "At least one lowercase letter",
        met: PASSWORD_LOWERCASE_REGEX.test(password)
    },
    {
        id: "special",
        label: "At least one special character that is not a hyphen or quotation mark",
        met: PASSWORD_SPECIAL_CHARACTER_REGEX.test(password)
    },
    {
        id: "match",
        label: "Matches the confirmation password",
        met: password.length > 0 && confirmPassword.length > 0 && password === confirmPassword
    }
]);
